// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9721":"90d1c0a50e05a62a","12970":"93ac99206ce9c27d"}[chunkId] + ".css";
};